/**
 * DENET BİLİŞİM — ENTRY POINT
 * The only script the layout loads directly. Everything else is imported by
 * the component that needs it, so pages never pay for behaviour they lack.
 */

import { onReady, onIdle, isThemeEditor } from './denet-core.js';
import { initMotion, initReveals, initRails } from './denet-motion.js';

onReady(() => {
  initMotion(document);

  // Sections re-rendered by the theme editor need their motion re-bound.
  if (isThemeEditor()) {
    document.addEventListener('shopify:section:load', (event) => {
      const target = /** @type {CustomEvent} */ (event).target;
      if (target instanceof HTMLElement) {
        initReveals(target);
        initRails(target);
      }
    });
  }
});

// Non-critical work waits for idle time so it never competes with LCP.
onIdle(() => {
  document.documentElement.classList.add('dn-hydrated');
});
